import React, { useEffect, useState } from 'react';
import '../styles/Hero.css';
import Silk from './Silk';
import Button from './Button';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  // Track scroll for parallax effect
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const opacity = Math.max(0, 1 - scrollY / 500);
  const translateY = scrollY * 0.5;

  return (
    <div className="hero" style={{ opacity }}>
      <div className="silk-background">
        <Silk
          speed={5}
          scale={1}
          color="#7B7481"
          noiseIntensity={1.5}
          rotation={0}
        />
      </div>
      
      <div className="hero-content" style={{ transform: `translateY(${translateY}px)` }}>
        <h1 className="hero-title">
          <span className="typewriter">Developer. Learner. Builder.
</span>
        </h1>
        
        <p className="hero-subtitle">
          Transforming ideas into exceptional digital experiences
        </p>
        
        <div className="hero-cta">
          <Button href="#projects">
            View My Work
          </Button>
          <Button href="#contact">
            Get In Touch
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-text">Scroll Down</div>
        <div className="scroll-arrow">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Section Divider */}
      <div className="section-divider">
        <div className="divider-line"></div>
        <div className="divider-glow"></div>
      </div>
    </div>
  );
};

export default Hero;
